import { SignInSection } from '../settings/SignInSection'

export function SignInView({ compact }: { compact?: boolean }) {
  return (
    <>
      <h1>Orovim</h1>
      <p className="sub">Sign in to generate replies</p>
      <SignInSection compact={compact} />
    </>
  )
}
